import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { HeadBar } from '../shared/components'
import { SettingsIcon } from '@/app/features/icons/Settings'
import { FaIcon, faClockRotateLeft } from '@/lib/fa'
import ImportHistoryModal from './pages/home/components/history/ImportHistoryModal'

type Props = {
  children: React.ReactNode
  companyId: string
}

export const ImportsLayout = ({ children, companyId }: Props) => {
  const { t, tSafe } = useLocalize()
  const [historyOpen, setHistoryOpen] = React.useState(false)
  const historyLabel = tSafe('importModule.import-history', 'Historia importów')

  return (
    <div className="module-imports tw-padding-4 tw-m-1 tw-flex tw-min-w-[900px] tw-flex-[1] tw-flex-col tw-max-h-[calc(100vh-8px)] tw-overflow-y-hidden tw-rounded-xl tw-border tw-border-base-300 tw-bg-base-100 tw-text-content-base">
      <HeadBar
        title={t('dashboard.import')}
        icon={<SettingsIcon />}
        actions={
          <button
            type="button"
            onClick={() => setHistoryOpen(true)}
            title={historyLabel}
            className="tw-inline-flex tw-h-9 tw-items-center tw-gap-2 tw-rounded-md tw-border tw-border-base-300 tw-bg-base-100 tw-px-3 tw-text-sm tw-font-medium tw-text-content-base tw-shadow-sm hover:tw-bg-base-200 hover:tw-text-primary"
          >
            <FaIcon icon={faClockRotateLeft} className="tw-h-4 tw-w-4" />
            {historyLabel}
          </button>
        }
      />

      <main className="p-6 tw-overflow-y-auto">{children}</main>

      {historyOpen && (
        <ImportHistoryModal
          companyId={companyId}
          handleClose={() => setHistoryOpen(false)}
        />
      )}
    </div>
  )
}
